const slugify = (value: string) =>
    value
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)+/g, '');

export const createBlogSlug = (title: string) => slugify(title) || 'untitled';

export const createBlogId = (title: string, date = new Date()) => {
    const dayStamp = date.toISOString().slice(0, 10).replace(/-/g, '');
    const timeStamp = date.getTime().toString(36);
    return `${dayStamp}-${createBlogSlug(title)}-${timeStamp}`;
};
